import { FC } from 'react'
import { Row, Col, Text, Breadcrumb } from '@/client/components'
import * as S from './styles'
import { FeaturedProps } from '../types'

export const Featured: FC<FeaturedProps> = ({ breadcrumb, heading, long_text }) => (
  <S.Featured>
    <Row>
      <Col>
        <Breadcrumb pages={breadcrumb} />
      </Col>
    </Row>
    <Row>
      <Col>
        <S.MainFeatured>
          <Text size='xxlg' weight='semiBlack' align='center'>
            {heading}
          </Text>
          <Text size='md' color='weak' margin='0 0 2.5rem' itemProp='name' lineHeight='1.4' align='center'>
            {long_text}
          </Text>
        </S.MainFeatured>
      </Col>
    </Row>
  </S.Featured>
)
